module.exports = __webpack_public_path__ + "media/images/espace jeux pour enfants-6f5f38b97da235a1a4a37b7835785308.svg";